'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SenderTypePropType = require('../prop-types/SenderTypePropType');

var _SenderTypePropType2 = _interopRequireDefault(_SenderTypePropType);

var _ChatHeadingConfigPropType = require('../chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _isChatRichTemplateMessage = require('conversations-schema/pubnub-message/operators/isChatRichTemplateMessage');

var _ChatBubble = require('ui-addon-messages/chat-message/ChatBubble');

var _ChatBubble2 = _interopRequireDefault(_ChatBubble);

var _ChatRichTemplate = require('./ChatRichTemplate');

var _ChatRichTemplate2 = _interopRequireDefault(_ChatRichTemplate);

var _MessageFooter = require('./MessageFooter');

var _MessageFooter2 = _interopRequireDefault(_MessageFooter);

var _InitialMessageAvatar = require('./InitialMessageAvatar');

var _InitialMessageAvatar2 = _interopRequireDefault(_InitialMessageAvatar);

var _MessageWrapper = require('./MessageWrapper');

var _MessageWrapper2 = _interopRequireDefault(_MessageWrapper);

var _ChatMessageText = require('./ChatMessageText');

var _ChatMessageText2 = _interopRequireDefault(_ChatMessageText);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'InitialChatMessage',

  propTypes: {
    chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
    coloring: (0, _RecordPropType2.default)('ColoringRecord'),
    currentRole: _SenderTypePropType2.default.isRequired,
    hideLabels: _react.PropTypes.bool,
    isFirstInGroup: _react.PropTypes.bool,
    isLastInGroup: _react.PropTypes.bool,
    message: (0, _RecordPropType2.default)('PubNubMessageRecord').isRequired,
    messageRole: _SenderTypePropType2.default.isRequired,
    nextMessage: (0, _RecordPropType2.default)('PubNubMessageRecord'),
    potentialResponders: _react.PropTypes.instanceOf(_immutable.List),
    publishMessage: _react.PropTypes.func,
    quickReplyDisabled: _react.PropTypes.bool,
    republishMessage: _react.PropTypes.func,
    responder: _react.PropTypes.oneOfType([(0, _RecordPropType2.default)('Responder'), (0, _RecordPropType2.default)('Visitor')]),
    sendFromResponders: _react.PropTypes.instanceOf(_immutable.List),
    showFooterContent: _react.PropTypes.bool
  },

  mixins: [_react2.default.addons.PureRenderMixin],

  isOwnMessage: function isOwnMessage() {
    var _props = this.props,
        messageRole = _props.messageRole,
        currentRole = _props.currentRole;

    return messageRole === currentRole;
  },
  getTooltipPlacement: function getTooltipPlacement() {
    return this.isOwnMessage() ? 'right' : 'left';
  },
  renderAvatar: function renderAvatar() {
    return _react2.default.createElement(_InitialMessageAvatar2.default, {
      potentialResponders: this.props.potentialResponders,
      sendFromResponders: this.props.sendFromResponders,
      message: this.props.message,
      messageRole: this.props.messageRole,
      currentRole: this.props.currentRole,
      responder: this.props.responder,
      isLastInGroup: this.props.isLastInGroup,
      tooltipPlacement: this.getTooltipPlacement(),
      chatHeadingConfig: this.props.chatHeadingConfig
    });
  },
  renderChatBubble: function renderChatBubble() {
    var message = this.props.message;


    if ((0, _isChatRichTemplateMessage.isChatRichTemplateMessage)(message)) {
      return _react2.default.createElement(_ChatRichTemplate2.default, { message: message });
    }

    var align = this.isOwnMessage() ? _ChatBubble.alignment.RIGHT : _ChatBubble.alignment.LEFT;

    return _react2.default.createElement(
      _ChatBubble2.default,
      {
        className: 'initial-chat-message',
        align: align,
        use: _ChatBubble.uses.DEFAULT,
        isFirstInGroup: this.props.isFirstInGroup,
        isLastInGroup: this.props.isLastInGroup
      },
      _react2.default.createElement(_ChatMessageText2.default, { message: message })
    );
  },
  renderFooter: function renderFooter() {
    return _react2.default.createElement(_MessageFooter2.default, {
      messageRole: this.props.messageRole,
      currentRole: this.props.currentRole,
      isLastInGroup: this.props.isLastInGroup,
      showFooterContent: this.props.showFooterContent,
      message: this.props.message,
      nextMessage: this.props.nextMessage,
      coloring: this.props.coloring,
      publishMessage: this.props.publishMessage,
      republishMessage: this.props.republishMessage,
      hideLabels: this.props.hideLabels,
      quickReplyDisabled: this.props.quickReplyDisabled,
      responder: this.props.responder
    });
  },
  render: function render() {
    return _react2.default.createElement(
      _MessageWrapper2.default,
      {
        footer: this.renderFooter(),
        avatar: this.renderAvatar(),
        isOwnMessage: this.isOwnMessage(),
        isAdmin: false,
        isLastInGroup: this.props.isLastInGroup
      },
      this.renderChatBubble()
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/InitialChatMessage.js
// module id = 1141
// module chunks = 2 3